import { render, staticRenderFns } from "./browser.html?vue&type=template&id=1ed8a4c9&scoped=true&"
import script from "./browser.js?vue&type=script&lang=js&"
export * from "./browser.js?vue&type=script&lang=js&"
import style0 from "./browser.scss?vue&type=style&index=0&id=1ed8a4c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed8a4c9",
  null
  
)

export default component.exports